module.exports = __webpack_public_path__ + "static/img/title-ar.93157f61.png";